import { render, staticRenderFns } from "./verHistorial.vue?vue&type=template&id=07439d8a&"
import script from "./verHistorial.vue?vue&type=script&lang=js&"
export * from "./verHistorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports